// src/api/ownerBookingsApi.js
import api from "./axios";

/**
 * POST /bookings/{bookingId}/accept
 * Accept booking (owner confirms)
 */
export async function acceptBooking(bookingId) {
  if (!bookingId) throw new Error("bookingId is required");
  const { data } = await api.post(`/bookings/${bookingId}/accept`);
  return data;
}

/**
 * POST /bookings/{bookingId}/assign-driver/{driverId}
 * POST /bookings/{bookingId}/accept
 * Combined helper: assign driver & confirm
 */
export async function assignDriverAndAcceptBooking(bookingId, driverId) {
  if (!bookingId || !driverId) {
    throw new Error("bookingId and driverId are required");
  }

  await api.post(`/bookings/${bookingId}/assign-driver/${driverId}`);
  const { data } = await api.post(`/bookings/${bookingId}/accept`);
  return data;
}

/**
 * ✅ Self-drive flow:
 * POST /drivers/self  -> create/get self-driver from OWNER JWT
 * then assign-driver + accept
 */
// ✅ Assign driver ONLY (no accept)
export async function assignDriverOnly(bookingId, driverId) {
  if (!bookingId || !driverId) {
    throw new Error("bookingId and driverId are required");
  }
  const { data } = await api.post(`/bookings/${bookingId}/assign-driver/${driverId}`);
  return data;
}

/**
 * ✅ Self-drive assign ONLY (no accept)
 * POST /drivers/self -> get/create self-driver
 * then assign-driver (NO /accept)
 */
export async function selfDriveAssignBookingOnly(bookingId, ownerProfilePayload) {
  if (!bookingId) throw new Error("bookingId is required");

  const { data: selfDriver } = await api.post(`/drivers/self`, ownerProfilePayload || {});
  const driverId = selfDriver?.id;

  if (!driverId) {
    throw new Error("Self-driver creation failed: missing driverId");
  }

  const { data } = await api.post(`/bookings/${bookingId}/assign-driver/${driverId}`);
  return data;
}



export async function selfDriveAssignAndAcceptBooking(bookingId, ownerProfilePayload) {
  if (!bookingId) throw new Error("bookingId is required");

  // ownerProfilePayload = { name, phoneNumber, email }
  const { data: selfDriver } = await api.post(`/drivers/self`, ownerProfilePayload || {});
  const driverId = selfDriver?.id;

  if (!driverId) {
    throw new Error("Self-driver creation failed: missing driverId");
  }

  await api.post(`/bookings/${bookingId}/assign-driver/${driverId}`);
  const { data } = await api.post(`/bookings/${bookingId}/accept`);
  return data;
}

/**
 * POST /bookings/{bookingId}/cancel
 * Body: text/plain (reason)
 */


export async function cancelBooking(bookingId, reason) {
  if (!bookingId) throw new Error("bookingId is required");
  const payload = reason || "";
  const { data } = await api.post(
    `/bookings/${bookingId}/owner-cancel-and-reassign`,
    payload,
    { headers: { "Content-Type": "text/plain" } }
  );
  return data;
}

export async function fetchOwnerBookingCancelConfig() {
  const { data } = await api.get("/api/public/app-config/search-mode", {
    headers: { "X-Bypass-Gate": "1" },
  });
  return {
    ownerCancelBeforePickupMinutes: Number(data?.scheduleOwnerCancelBeforePickupMinutes ?? 0),
  };
}
